import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SiteContentProvider } from './context/SiteContentContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Gallery from './components/Gallery';
import WhyChooseUs from './components/WhyChooseUs';
import AboutUs from './components/AboutUs';
import ContactForm from './components/ContactForm';
import Footer from './components/Footer';
import AdminPanel from './pages/AdminPanel';
import ServiceDetail from './components/ServiceDetail';
import LandingPage from './components/LandingPage';

// Google Analytics component - different GA for /koda page
const GoogleAnalytics = () => {
  const location = useLocation();
  const GA_ID_DEFAULT = 'G-6S9K37S7ER';
  const GA_ID_KODA = 'G-3X1Z5RMJPV';

  useEffect(() => {
    const isKodaPage = location.pathname === '/koda';
    const gaId = isKodaPage ? GA_ID_KODA : GA_ID_DEFAULT;

    // Check if this specific GA script already exists
    const existingScript = document.querySelector(`script[src*="${gaId}"]`);
    
    if (!existingScript) {
      // Load Google Analytics script
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script);

      // Initialize gtag
      window.dataLayer = window.dataLayer || [];
      function gtag() { window.dataLayer.push(arguments); }
      window.gtag = gtag;
      gtag('js', new Date());
      gtag('config', gaId);
    }
  }, [location.pathname]);

  // Track page views
  useEffect(() => {
    const isKodaPage = location.pathname === '/koda';
    const gaId = isKodaPage ? GA_ID_KODA : GA_ID_DEFAULT;
    
    if (window.gtag) {
      window.gtag('config', gaId, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

const HomePage = () => (
  <>
    <Navbar />
    <Hero />
    <Services />
    <Gallery />
    <WhyChooseUs />
    <AboutUs />
    <ContactForm />
    <Footer />
  </>
);

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <SiteContentProvider>
        <BrowserRouter>
          <GoogleAnalytics />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/storitev/:serviceId" element={<ServiceDetail />} />
            <Route path="/koda" element={<LandingPage />} />
            <Route path="/vizitka" element={<LandingPage />} />
            <Route path="/welcome/:source" element={<LandingPage />} />
          </Routes>
        </BrowserRouter>
      </SiteContentProvider>
    </div>
  );
}

export default App;
